module.exports = __webpack_public_path__ + "static/img/14010107.d150fe49.png";